package org.example.project.screens_sys

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch
import org.example.project.enginemodule.SHOP_PURCHASED_DATE_KEY
import org.example.project.enginemodule.SHOP_PURCHASED_KEY
import org.example.project.enginetabular.TabularScreen
import org.example.project.utils.All

@Composable
fun SysModulauskunft() {
    var module by remember { mutableStateOf<List<All>>(emptyList()) }
    val scope = rememberCoroutineScope()

    fun checkboxText(value: Boolean): String = if (value) "\u2705" else "\u2b1c"

    fun moduleImBesitz(modul: All): Boolean =
        modul.shopPurchased || modul.modulInstalliert

    fun moduleDatum(modul: All): String =
        modul.shopPurchasedDate
            .takeIf { it.isNotBlank() }
            ?: modul.aktiviertAm?.takeIf { it.isNotBlank() }
            ?: modul.modulErstelltAm.takeIf { it.isNotBlank() }
            ?: ""

    suspend fun loadRows(): List<All> {
        val kunden = KundenSetupApi.loadCompanies()
            .sortedBy { it.firma.lowercase() }

        return kunden.flatMap { kunde ->
            val firmenId = kunde.firmenId.ifBlank { kunde.id }
            if (firmenId.isBlank()) {
                emptyList()
            } else {
                KundenSetupApi.loadModules(firmenId)
                    .filter { it.modulId > 0 && moduleImBesitz(it) }
                    .sortedWith(compareBy<All> { it.modulName.ifBlank { "Modul ${it.modulId}" } }.thenBy { it.modulId })
                    .map { modul ->
                        modul.copy(
                            id = "${firmenId}_${modul.id.ifBlank { modul.modulId.toString() }}",
                            firmenId = firmenId,
                            firma = kunde.firma
                        )
                    }
            }
        }
    }

    fun mapRow(modul: All): List<String> = listOf(
        modul.modulId.toString(),
        modul.firmenId,
        modul.firma,
        modul.modulName.ifBlank { "Modul ${modul.modulId}" },
        checkboxText(moduleImBesitz(modul)),
        checkboxText(modul.modulInstalliert),
        moduleDatum(modul),
        modul.aktiviertAm.orEmpty(),
        modul.aktiviertUm.orEmpty(),
        modul.aktiviertVon.orEmpty()
    )

    TabularScreen(
        screenKey = "Modulauskunft",
        rollenKey = "Modulauskunft",
        title = "Modulauskunft",
        headers = listOf(
            "ID",
            "Firmen-ID",
            "Firma",
            "Modulname",
            "Modul im Besitz",
            "Modul aktiv",
            "Datum",
            "Aktiviert am",
            "Aktiviert um",
            "Aktiviert von"
        ),
        models = module,
        data = module.map { modul -> modul.id to mapRow(modul) },
        editable = false,
        includeMetadata = true,
        allowCreate = false,
        allowDelete = false,
        nonEditableCols = setOf("Modul im Besitz", "Modul aktiv"),
        dropdownOptions = mapOf(
            "Modul im Besitz" to listOf("\u2b1c", "\u2705"),
            "Modul aktiv" to listOf("\u2b1c", "\u2705")
        ),
        onSearchWithFilters = { filters ->
            scope.launch {
                module = KundenSetupApi.searchModuleAuskunft(filters)
            }
        },
        onCommit = {}
    )
}
